import { useContext, useEffect, useState } from 'react';
import { Range, getTrackBackground } from 'react-range';
import { FilterContext } from '../../../filterTools';

const STEP = 10;
const MIN = 0;
const MAX = 200;

export const LivingSpaceRangeSlider = ({
  tabIndex,
  updateRangeTags,
}: {
  tabIndex?: number;
  updateRangeTags(name: string, minVal: number, maxVal: number): void;
}): JSX.Element => {
  const filterContext = useContext(FilterContext);
  const [liveLivingSpaceRange, setLiveLivingSpaceRange] = useState([MIN, MAX]);

  // reset range slider when tags is reset
  const [initValHasSet, setInitValHasSet] = useState(false);

  useEffect(() => {
    if (filterContext.tags.length === 0) {
      setLiveLivingSpaceRange([MIN, MAX]);
    } else if (!initValHasSet) {
      setInitValHasSet(true);
      const filterPriceTag = filterContext.tags.find(
        (x) => x.name === 'Boarea' && x.type === 'rangeTag'
      );
      setLiveLivingSpaceRange([
        filterPriceTag?.minVal || MIN,
        filterPriceTag?.maxVal || MAX,
      ]);
    } else {
      const filterPriceTag = filterContext.tags.find(
        (x) => x.name === 'Boarea' && x.type === 'rangeTag'
      );
      setLiveLivingSpaceRange([
        filterPriceTag?.minVal || MIN,
        filterPriceTag?.maxVal || MAX,
      ]);
    }
  }, [filterContext.tags, initValHasSet]);

  return (
    <div className="mx-8">
      <output
        className="flex justify-between -mx-3 mt-3 mb-2 lg:mb-0 xxl:mb-2 text-base"
        id="output"
      >
        <div className="font-icb">Boarea</div>
        <div>
          {liveLivingSpaceRange[0]}-{liveLivingSpaceRange[1]}
          {liveLivingSpaceRange[1] === MAX ? '+' : ''}m²
        </div>
      </output>
      <Range
        step={STEP}
        min={MIN}
        max={MAX}
        values={liveLivingSpaceRange}
        onChange={(LivingSpaceRange) => {
          setLiveLivingSpaceRange(LivingSpaceRange);
        }}
        onFinalChange={() => {
          updateRangeTags(
            'Boarea',
            liveLivingSpaceRange[0],
            liveLivingSpaceRange[1]
          );
        }}
        renderTrack={({ props, children }) => (
          <div
            onMouseDown={props.onMouseDown}
            onTouchStart={props.onTouchStart}
            className="h-10 pointer-events-none lg:pointer-events-auto"
            style={{
              ...props.style,
              display: 'flex',
              width: '100%',
            }}
          >
            <div
              ref={props.ref}
              style={{
                height: '3px',
                width: '100%',
                borderRadius: '4px',
                background: getTrackBackground({
                  values: liveLivingSpaceRange,
                  colors: ['#ccc', '#005094', '#ccc'],
                  min: MIN,
                  max: MAX,
                  rtl: false,
                }),
                alignSelf: 'center',
              }}
            >
              {children}
            </div>
          </div>
        )}
        renderThumb={({ props, isDragged }) => (
          <div
            {...props}
            className="flex justify-evenly items-center bg-white shadow-bs40 p-2 border border-grey100 rounded-full outline-none w-8 h-8 pointer-events-auto slider-thumb"
            tabIndex={tabIndex}
          >
            <div
              className="w-[1px] h-3"
              style={{
                backgroundColor: isDragged ? '#005094' : '#CCC',
              }}
            />
            <div
              className="w-[1px] h-3"
              style={{
                backgroundColor: isDragged ? '#005094' : '#CCC',
              }}
            />
          </div>
        )}
      />
    </div>
  );
};
